module.exports = __webpack_public_path__ + "img/16_41.5e19a27a.png";